import styles from "./DeliverCard.module.scss";

const DeliverCard = ({ className, delivery, minHeight }) => {
  const { city, state, zip, date } = delivery || {};

  return (
    <div className={className} style={{ minHeight }}>
      <span className={styles.title}>Deliver to:</span>
      <p className={styles.value}>
        {city}, {state} {zip}
      </p>
      <span className={styles.title}>Delivery date:</span>
      <p className={styles.value}>{date}</p>
    </div>
  );
};

export default DeliverCard;
